import React from "react";
import { useSelector } from "react-redux";
import { Box, Flex, Text } from "rebass";

import { getActiveRecordContent } from "../../../store/modules/library/selectors";
import { getRate } from "../../../store/modules/audio/selectors";

import { RecordIcon } from "../RecordIcon";

import { rateToValue } from "../../../utils/converSpeed";

export const ActiveRecord: React.FC = () => {
  const rate = useSelector(getRate);
  const record = useSelector(getActiveRecordContent);

  if (!record) return null;

  const {
    title,
    wordCount,
    coverImagePath,
  } = record;

  const time = (wordCount / rateToValue(rate)).toFixed(0);

  return (
    <Flex
      width="250px"
      alignItems="center"
    >
      <RecordIcon
        variant="md"
        title={title}
        coverImagePath={coverImagePath}
      />

      <Box
        flex="1"
        ml="16px"
        css="overflow: hidden;"
      >
        <Text
          width={1}
          mb="5px"
          fontSize="18px"
          fontWeight="bold"
          color="zodiac"
          css="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
        >
          {title}
        </Text>

        <Text
          fontSize="14px"
          color="#7b80aa"
        >
          {`~ ${time}min`}
        </Text>
      </Box>
    </Flex>
  );
};
